import { EventEmitter } from '@angular/core';
import {
  ColumnaMaestra,
  RangeRefactoryTableDynamicComponent,
  CalendarRefactoryTableDynamicComponent,
  TimerRefactoryTableDynamicComponent,
  DateTimerRefactoryTableDynamicComponent,
  RangeDateRefactoryTableDynamicComponent,
  RangeTimerRefactoryTableDynamicComponent,
  CheckTableComponent
} from '@app/shared';

export class TeacherConfigService {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {
    mode: 'external',
    noDataMessage: 'No se encontraron resultados',
    actions: false,
    attr: {
      class: 'table-bordered table-hover pointer'
    },
    columns: {}
  };

  constructor () {}

  /**
   * Genera las columnas de la tabla de cada tabla dinamica
   *
   * @param {ColumnaMaestra[]} structureTable
   * @param {boolean} [users=false]
   * @returns
   * @memberof TeacherConfigService
   */
  getDynamicColumns(structureTable: ColumnaMaestra[], users: boolean = false) {
    const self = this;
    const columns = {};
    var accents = require('remove-accents');
    columns['id'] = {
      editable: false,
      addable: false,
      sort: false,
      title: 'Id',
      width: '10%',
      filter: {
        inputClass: 'form-control',
      },
    };
    structureTable.sort((a, b) => a.orden - b.orden);
    structureTable.forEach(control => {
      switch (control.tipo_campo['nombre']) {
        case 'textarea':
        columns[control.id + ' '] = {
          editable: false,
          addable: false,
          sort: false,
          title: control.nombre,
          filter: false
        };
        break;
        case 'checkbox':
          columns[control.id + ' '] = {
            editable: false,
            addable: false,
            sort: false,
            title: control.nombre,
            filter: {
              inputClass: 'form-control',
              type: 'checkbox',
              config: {
                true: 'true',
                false: 'false',
                resetText: 'Todo',
              },
            },
            type: 'custom',
            renderComponent: CheckTableComponent,
          };
          break;
        case 'date-time-picker':
          columns[control.id + ' '] = {
            title: control.nombre,
            sort: true,
            filter: {
              inputClass: 'form-control',
            },
            type: 'custom',
          };
          switch (control.propiedades.tipo) {
            case 'calendar':
              columns[control.id + ' ']['renderComponent'] = CalendarRefactoryTableDynamicComponent;
              break;
            case 'timer':
              columns[control.id + ' ']['renderComponent'] = TimerRefactoryTableDynamicComponent;
              break;
            case 'dateTimer':
              columns[control.id + ' ']['renderComponent'] = DateTimerRefactoryTableDynamicComponent;
              break;
            case 'rangeDate':
              columns[control.id + ' ']['renderComponent'] = RangeDateRefactoryTableDynamicComponent;
              break;
            case 'rangeTime':
              columns[control.id + ' ']['renderComponent'] = RangeTimerRefactoryTableDynamicComponent;
              break;
            default:
              columns[control.id + ' ']['renderComponent'] = RangeRefactoryTableDynamicComponent;
              break;
          }
          break;
          case 'ngSelect':
            columns[control.id + '_valor'] = {
              editable: false,
              addable: false,
              sort: true,
              title: control.nombre,
              filter: {
                inputClass: 'form-control',
              },
              filterFunction: (cell?: any, search?: string) => {
                if (cell){
                  if(typeof(cell) == 'string'){
                    return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                  }else{
                    return cell.toString().includes(search) ? true : false;
                  } 
                }else{
                  return false;
                }
              }
            };
            break;
          default:
            if (control.tipo_campo['nombre'] !== 'label') {
              columns[control.id + ' '] = {
                editable: false,
                addable: false,
                sort: true,
                title: control.nombre,
                filter: {
                  inputClass: 'form-control',
                },
                filterFunction: (cell?: any, search?: string) => {
                  if (cell){
                    if(typeof(cell) == 'string'){
                      return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                    }else{
                      return cell.toString().includes(search) ? true : false;
                    } 
                  }else{
                    return false;
                  }
                }
              };
            }
            break;
      }
    });

    if (users) {
      // columns['login'] = {
      //   editable: false,
      //   addable: false,
      //   sort: false,
      //   title: 'Login',
      //   filter: {
      //     inputClass: 'form-control',
      //     type: 'checkbox',
      //     config: {
      //       true: 'Sí',
      //       false: 'No',
      //       resetText: 'Todo',
      //     },
      //   }
      // };
    }

    this.settings.columns = columns;
    return this.settings;

  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/shared/teacher-config.service.ts